import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BaseModalComponent } from '../../../../core/layout/components/abstracts/base-modal.component';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { CashInOutModalComponent } from '../cash-in-out-modal/cash-in-out-modal.component';
import { ApiErrorResponse } from '../../../../core/classes/ApiErrorResponse';
import { WorkerService } from '../../../worker/core/services/WorkerService';
import { WebCashPermissionControlDirective } from '../../../auth/core/directives/web-cash-permission-control.directive';

@Component({
  selector: 'app-safe-actions-modal',
  standalone: true,
  imports: [
    ModalComponent,
    TranslatePipe,
    CashInOutModalComponent,
    WebCashPermissionControlDirective,
  ],
  templateUrl: './safe-actions-modal.component.html',
  styleUrl: './safe-actions-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SafeActionsModalComponent extends BaseModalComponent {

  private readonly _workerService = inject(WorkerService);

  public override open(val?: any): void {
    if (!this.permissionService.hasPermission(this.permissionKeys.WebCxCashSafes)) {
      return;
    }

    super.open(val);
  }

  public openSafe(): void {
    if (!this.permissionService.hasPermission(this.permissionKeys.WebCxCashSafes)) {
      return;
    }

    this._workerService.openSafe().subscribe({
      error: ({ error }: ApiErrorResponse) => {
        this.notificationService.pushError(
          'Fehler'.trans('notifications/error.Title'),
          error.message.trans(`open-safe/notifications/${error.message}.Message`)
        );
      }
    });
  }
}
